var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyLeoPrimeIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 126,
    viewBox: "0 0 122 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 126,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.046 48.473C64.448 59.327 31.931 59.326 1.334 48.473L0 48V94.71L1.334 94.236C31.931 83.384 64.448 83.384 95.046 94.236L96.38 94.71V48L95.046 48.473ZM2 50.824C12.08 54.292 22.36 56.595 32.708 57.748V84.963C22.36 86.116 12.079 88.419 2 91.886V50.824ZM34.708 84.756V57.956C43.682 58.826 52.699 58.826 61.674 57.956V84.756C52.699 83.886 43.682 83.886 34.708 84.756ZM94.38 91.886C84.301 88.419 74.021 86.115 63.673 84.963V57.749C74.02 56.596 84.301 54.293 94.38 50.825V91.886Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLeoPrimeIcon3);
export default __webpack_public_path__ + "static/media/why-leo-prime-icon-3.0f7800ef37c44201513f28f020786a82.svg";
export { ForwardRef as ReactComponent };